module.exports = __webpack_public_path__ + "img/Certificate_ourcompany.cf3d7286.png";